import { useDispatch } from "react-redux";
import { useCallback, useEffect } from "react";
import { socketSetup } from "../../library/socket-io/socket-setup";
import { requestAmendmentAPI } from "../../api/request-amendment/request-amendment-api";
import { proposalAPI } from "../../api/gms/proposal/proposal-api";
import { useModalAccess } from "../../components/global/modal/use-modal-access";

interface SocketPayload {
    proposalId: number;
}

export const useAmendmentsSocket = () => {
    const dispatch = useDispatch();
    const { currentProposalId } = useModalAccess();

    const invalidate = useCallback(
        ({ proposalId }: SocketPayload) => {
            dispatch(
                requestAmendmentAPI.util.invalidateTags([
                    { type: "Amendments", id: "LIST" },
                ])
            );

            // Ignore updates for other proposals
            if (proposalId !== currentProposalId) return;

            dispatch(
                requestAmendmentAPI.util.invalidateTags([
                    { type: "Amendments", id: proposalId },
                ])
            );

            dispatch(
                proposalAPI.util.invalidateTags([
                    { type: "Proposal", id: proposalId },
                ])
            );
        },
        [dispatch, currentProposalId]
    );

    useEffect(() => {
        if(!socketSetup) return
    
        socketSetup.on("requestAmendment", invalidate)
        socketSetup.on("approveAmendment", invalidate)
        socketSetup.on("declineAmendment", invalidate)
    
        return () => {
            socketSetup.off("requestAmendment", invalidate)
            socketSetup.off("approveAmendment", invalidate)
            socketSetup.off("declineAmendment", invalidate)
        }
    }, [invalidate])
}